import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { Auth } from '@angular/fire/auth';
import { FooterComponent } from '../../components/footer/footer.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
   selector: 'login-page',
   standalone: true,
   imports: [FooterComponent, NavbarComponent, TranslateModule, FormsModule, RouterLink],
   templateUrl: './login-page.component.html',
   styleUrl: './login-page.component.scss',
})
export class LoginPageComponent {
   currentSection = 'login';
   email = '';
   password = '';
   loading = false;
   errorKey = '';
   isRegister = false;

   constructor(private auth: Auth, private router: Router, private route: ActivatedRoute) {}

   /**
    * Where to go once signed in: `?next=` when it is a path on this site (so
    * "Put it on my shop" comes back to add the shop), the home page otherwise.
    * Never another origin: `//evil.example` and `https:` are refused.
    */
   get next(): string {
      const next = this.route.snapshot.queryParamMap.get('next') ?? '';
      return next.startsWith('/') && !next.startsWith('//') && !next.startsWith('/\\') ? next : '/';
   }

   async signInWithGoogle() {
      this.loading = true;
      this.errorKey = '';
      try {
         await signInWithPopup(this.auth, new GoogleAuthProvider());
         this.router.navigateByUrl(this.next);
      } catch (e: any) {
         this.errorKey = 'pages.login-page.errorGeneral';
      } finally {
         this.loading = false;
      }
   }

   async signInWithEmail() {
      if (!this.email || !this.password) return;
      this.loading = true;
      this.errorKey = '';
      try {
         if (this.isRegister) {
            await createUserWithEmailAndPassword(this.auth, this.email, this.password);
         } else {
            await signInWithEmailAndPassword(this.auth, this.email, this.password);
         }
         this.router.navigateByUrl(this.next);
      } catch (e: any) {
         if (e.code === 'auth/wrong-password' || e.code === 'auth/invalid-credential') {
            this.errorKey = 'pages.login-page.errorWrongPassword';
         } else if (e.code === 'auth/email-already-in-use') {
            this.errorKey = 'pages.login-page.errorEmailInUse';
         } else if (e.code === 'auth/weak-password') {
            this.errorKey = 'pages.login-page.errorWeakPassword';
         } else {
            this.errorKey = 'pages.login-page.errorGeneral';
         }
      } finally {
         this.loading = false;
      }
   }
}
